var map = {
	"./app/components/App/AppFooter/i18n.ts": 81115,
	"./app/components/App/AppHeader/i18n.ts": 79980,
	"./app/components/Courses/CourseItem/i18n.ts": 23188,
	"./app/components/Courses/CourseItemHighlight/i18n.ts": 88290,
	"./app/components/Courses/CourseItemHighlightShowcase/i18n.ts": 29545,
	"./app/components/Courses/LessonItem/i18n.ts": 20920,
	"./app/components/Courses/SectionItem/i18n.ts": 68726,
	"./app/components/Player/i18n.ts": 22012,
	"./app/components/Routes/i18n.ts": 6856,
	"./app/screens/Dashboard/screens/AboutUs/components/ContactUsForm/i18n.ts": 35268,
	"./app/screens/Dashboard/screens/AboutUs/i18n.ts": 44857,
	"./app/screens/Dashboard/screens/ActiveCourse/i18n.ts": 6579,
	"./app/screens/Dashboard/screens/Categories/i18n.ts": 15784,
	"./app/screens/Dashboard/screens/Contact/i18n.ts": 95774,
	"./app/screens/Dashboard/screens/Course/i18n.ts": 91515,
	"./app/screens/Dashboard/screens/Donate/i18n.ts": 38721,
	"./app/screens/Dashboard/screens/Home/i18n.ts": 96528,
	"./app/screens/Dashboard/screens/NotFound/i18n.ts": 95017,
	"./app/screens/Dashboard/screens/Privacy/i18n.ts": 63375,
	"./app/screens/Dashboard/screens/Profile/i18n.ts": 36079,
	"./app/screens/Dashboard/screens/Search/i18n.ts": 26102,
	"./app/screens/Dashboard/screens/UserCourses/i18n.ts": 82880,
	"./app/screens/DeleteAccount/components/ConfirmationModal/i18n.ts": 38623,
	"./app/screens/DeleteAccount/i18n.ts": 10064,
	"./app/screens/Login/i18n.ts": 29351,
	"./app/screens/RecoverPassword/i18n.ts": 20941,
	"./app/screens/Registration/i18n.ts": 26545,
	"./config/i18n.js": 24369,
	"./constants/i18n.ts": 83667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42446;